document.addEventListener('DOMContentLoaded', function () {
  // ================================
  // 1. Handle sticky section class
  // ================================
  document.querySelectorAll('[data-sticky]').forEach(function (wrapper) {
    var section = wrapper.closest('.scroll-to-container-section');
    if (!section) return;

    var isSticky = wrapper.dataset.sticky === 'true';
    section.classList.toggle('scroll-to-container-section-is-sticky', isSticky);
  });

  // ================================
  // 2. Scroll-to-section functionality
  // ================================
  var tabs = document.querySelectorAll('.scroll-to-collection-list-item');
  var tabContainer = document.querySelector('.scroll-to-container-section');
  var isUserScrolling = true;

  if (!tabContainer || tabs.length === 0) return;

  // ================================
  // 3. Get accurate tab height
  // ================================
  function getTabHeight() {
    return tabContainer.getBoundingClientRect().height + 20;
  }

  // ================================
  // 4. Update section positions using getBoundingClientRect
  // ================================
  function getSectionPositions() {
    var positions = [];
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    tabs.forEach(function (tab, index) {
      var targetId = tab.getAttribute('data-target');
      var targetElement = document.querySelector('[data-target-section-id="' + targetId + '"]');

      if (targetElement) {
        var rect = targetElement.getBoundingClientRect();
        positions.push({
          id: targetId,
          element: targetElement,
          top: rect.top + scrollTop,
          bottom: rect.bottom + scrollTop,
          index: index,
          tab: tab
        });
      }
    });

    return positions;
  }

  // ================================
  // 5. Click handler for tabs
  // ================================
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var targetId = this.getAttribute('data-target');
      var targetElement = document.querySelector('[data-target-section-id="' + targetId + '"]');

      if (targetElement) {
        isUserScrolling = false;
        
        var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - getTabHeight();
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });

        // Update active state immediately
        tabs.forEach(function (t) {
          t.classList.remove('active');
        });
        this.classList.add('active');

        // Re-enable scroll detection after animation completes
        setTimeout(function () {
          isUserScrolling = true;
        }, 1000);
      }
    });
  });

  // ================================
  // 6. Improved scroll handler for Mac
  // ================================
  function updateActiveTab() {
    if (!isUserScrolling) return;

    var sectionPositions = getSectionPositions();
    if (sectionPositions.length === 0) return;

    var scrollPosition = window.pageYOffset + getTabHeight() + 50;
    var currentSection = null;

    // Find current section - only if we're actually IN a section
    for (var i = 0; i < sectionPositions.length; i++) {
      var section = sectionPositions[i];
      
      if (scrollPosition >= section.top && scrollPosition < section.bottom) {
        currentSection = section;
        break;
      }
    }

    // Don't activate first section if we're before it (REMOVED)
    // Don't activate last section if we're after it (REMOVED)

    // Update active tab - only if we found a current section
    tabs.forEach(function (tab) {
      tab.classList.remove('active');
    });

    if (currentSection) {
      currentSection.tab.classList.add('active');
      scrollTabIntoView(currentSection.tab);
    }
  }

  // ================================
  // 7. Scroll active tab into view
  // ================================
  function scrollTabIntoView(activeTab) {
    var container = document.querySelector('.scroll-to-collection-list-inner');
    if (!container) return;

    var containerRect = container.getBoundingClientRect();
    var tabRect = activeTab.getBoundingClientRect();

    if (tabRect.left < containerRect.left) {
      container.scrollLeft -= (containerRect.left - tabRect.left) + 20;
    } else if (tabRect.right > containerRect.right) {
      container.scrollLeft += (tabRect.right - containerRect.right) + 20;
    }
  }

  // ================================
  // 8. Debounced scroll event (better for Mac)
  // ================================
  var scrollTimeout;
  var lastScrollTime = 0;

  window.addEventListener('scroll', function () {
    var now = Date.now();
    
    if (now - lastScrollTime > 50) {
      updateActiveTab();
      lastScrollTime = now;
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      updateActiveTab();
    }, 100);
  }, { passive: true });

  // ================================
  // 9. Debounced resize event
  // ================================
  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      updateActiveTab();
    }, 250);
  });

  // ================================
  // 10. Initialize - Remove all active classes initially
  // ================================
  function initialize() {
    // Remove all active classes on initialization
    tabs.forEach(function (tab) {
      tab.classList.remove('active');
    });
    // Don't call updateActiveTab() on init
  }

  // Try multiple initialization points for reliability
  if (document.readyState === 'loading') {
    window.addEventListener('load', initialize);
  } else {
    initialize();
  }

  // Backup initialization
  setTimeout(initialize, 100);
  setTimeout(initialize, 500);
});